import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
import { RecuperarContrasenaService } from '../_services';
import { first } from 'rxjs/operators';

@Component({
  selector: 'app-cambiar-contrasena',
  templateUrl: './cambiar-contrasena.component.html',
  styleUrls: ['./cambiar-contrasena.component.css']
})
export class CambiarContrasenaComponent implements OnInit {
  formPassword: FormGroup;
  submitted = false;
  token: string;
  error: string;
  constructor(
    private formBuilder: FormBuilder,
    private route: ActivatedRoute,
    private router: Router,
    private recuperarContrasenaService: RecuperarContrasenaService
  ) {}

  ngOnInit() {
    this.formPassword = this.formBuilder.group({
      nuevaContrasena: [{ value: '', disabled: true }, Validators.required],
      confirmarContrasena: [{ value: '', disabled: true }, Validators.required]
    });

    this.formPassword.setValidators(this.passwordMatchValidator);
    this.error = '';
    this.token = this.route.snapshot.paramMap.get('token');
    console.log(this.token);
    this.recuperarContrasenaService
      .postVerificarRecuperacionContrasena(this.token)
      .pipe(first())
      .subscribe(data => {
        if (data['id']) {
          this.f.nuevaContrasena.enable();
          this.f.confirmarContrasena.enable();
        } else {
          this.error = data['message'];
          this.submitted = false;
        }
      });
  }

  // convenience getter for easy access to form fields
  get f() {
    return this.formPassword.controls;
  }
  onSubmit() {
    this.submitted = true;
    console.log('Submit form cambiar contraseña');
    // stop here if form is invalid
    if (this.formPassword.invalid) {
      return;
    }

    this.recuperarContrasenaService
      .postCambiarContrasena(
        this.f.nuevaContrasena.value,
        this.f.confirmarContrasena.value,
        this.token
      )
      .pipe(first())
      .subscribe(data => {
        if (data['id']) {
          alert('Se ha modificado la contraseña. ');
          this.submitted = false;
          this.f.nuevaContrasena.setValue('');
          this.f.confirmarContrasena.setValue('');
          this.router.navigate(['/login']);
        } else {
          this.error = data['message'];
          this.submitted = false;
        }
      });
  }

  passwordMatchValidator(g: FormGroup) {
    if (g.get('nuevaContrasena').value === g.get('confirmarContrasena').value) {
      g.controls['nuevaContrasena'].setErrors(null);
      return null;
    } else {
      g.controls['nuevaContrasena'].setErrors({ mismatch: true });
      return { mismatch: true };
    }
  }
}
